import React from "react";
import { Button } from "../ui/button";
import { formatProgramDraftSavedAt } from "../../lib/programDraft";

const savedLabel = (value) => formatProgramDraftSavedAt(value) || "an unknown time";

export const ProgramDraftRecovery = ({ conflict, recovered, serverLoadError, onRetryServer, onUseLocal, onUseServer, onStartOver }) => {
  if (conflict) {
    return (
      <section role="alertdialog" aria-labelledby="program-draft-conflict-title" aria-describedby="program-draft-conflict-description" className="mb-4 rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-950">
        <h3 id="program-draft-conflict-title" className="font-semibold">Choose which unfinished setup to continue</h3>
        <p id="program-draft-conflict-description" className="mt-1 text-amber-900">This device and Sporthouse have different saved changes. Choosing a copy will replace the other one when autosave resumes.</p>
        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          <Button type="button" variant="outline" onClick={onUseLocal} className="h-auto justify-start border-amber-300 bg-white px-4 py-3 text-left text-amber-950 hover:bg-amber-100">
            <span><strong className="block">Use this device’s copy</strong><span className="mt-1 block text-xs font-normal">Saved at {savedLabel(conflict.localSavedAt)}</span></span>
          </Button>
          <Button type="button" variant="outline" onClick={onUseServer} className="h-auto justify-start border-amber-300 bg-white px-4 py-3 text-left text-amber-950 hover:bg-amber-100">
            <span><strong className="block">Use the Sporthouse copy</strong><span className="mt-1 block text-xs font-normal">Saved at {savedLabel(conflict.serverSavedAt)}</span></span>
          </Button>
        </div>
      </section>
    );
  }

  if (serverLoadError) {
    return (
      <div role="alert" className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-950">
        <div>
          <p className="font-semibold">Sporthouse could not check for a newer saved setup</p>
          <p className="mt-1 text-xs text-amber-900">Your device copy is safe. Cloud autosave is paused until the check succeeds.</p>
        </div>
        <Button type="button" variant="outline" size="sm" onClick={onRetryServer} className="border-amber-300 bg-white text-amber-950 hover:bg-amber-100">Retry Sporthouse</Button>
      </div>
    );
  }

  if (!recovered) return null;
  return (
    <div role="status" className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-blue-200 bg-blue-50 p-3 text-sm text-blue-800">
      <div>
        <p className="font-medium">Your unfinished setup was recovered</p>
        <p className="text-xs text-blue-700">Changes continue saving securely and can be resumed on another device.</p>
      </div>
      <Button type="button" variant="outline" size="sm" onClick={onStartOver} className="border-blue-300 bg-white text-blue-800 hover:bg-blue-100">Start over</Button>
    </div>
  );
};

export const ProgramDraftSaveStatus = ({ serverSavedAt, localSavedAt, saving }) => {
  if (saving) return <span role="status">Saving to Sporthouse…</span>;
  if (serverSavedAt) return <span role="status">Saved to Sporthouse at {savedLabel(serverSavedAt)}</span>;
  if (localSavedAt) return <span role="status">Saved on this device</span>;
  return null;
};
